var _rect, _path, _path2, _line, _line2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 67,
    viewBox: "0 0 41 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 41,
    height: 1,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7595 12H22.6075C22.5195 12 22.4495 11.978 22.3975 11.934C22.3495 11.886 22.3095 11.834 22.2775 11.778L19.9735 8.166C19.9415 8.262 19.9055 8.344 19.8655 8.412L17.6215 11.778C17.5815 11.834 17.5375 11.886 17.4895 11.934C17.4455 11.978 17.3835 12 17.3035 12H16.2235L19.1815 7.584L16.3435 3.402H17.5015C17.5855 3.402 17.6475 3.416 17.6875 3.444C17.7275 3.472 17.7635 3.512 17.7955 3.564L20.0395 7.008C20.0675 6.924 20.1095 6.832 20.1655 6.732L22.2835 3.588C22.3155 3.532 22.3535 3.488 22.3975 3.456C22.4415 3.42 22.4935 3.402 22.5535 3.402H23.6635L20.8135 7.53L23.7595 12Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 65.1307H35.0379C36.163 65.1307 37.1842 64.6729 37.925 63.9343C38.6658 63.1956 39.1251 62.1774 39.1251 61.0556V43.4291C39.1251 42.726 38.9671 42.0776 38.6647 41.5099C38.3624 40.9411 37.9117 40.4466 37.33 40.0534L23.2918 30.5869C22.5828 30.1083 21.7905 29.8701 21.0007 29.8701C20.2109 29.8701 19.4186 30.1094 18.7097 30.5869L4.67138 40.0534C4.08973 40.4454 3.63905 40.9411 3.33672 41.5099C3.03437 42.0776 2.87635 42.726 2.87635 43.4291V61.0556C2.87635 62.1775 3.33558 63.1956 4.0764 63.9343C4.81719 64.6729 5.83845 65.1307 6.96357 65.1307H21.0019H20.9996ZM35.0379 67H6.96202C5.32016 67 3.82857 66.3321 2.74864 65.2554C1.66988 64.1798 1 62.6929 1 61.0556V43.4291C1 42.4171 1.23374 41.4721 1.68073 40.6333C2.12658 39.797 2.78143 39.0732 3.62383 38.5055L17.6621 29.0389C18.6882 28.3466 19.843 28 21 28C22.157 28 23.3118 28.3466 24.3379 29.0389L38.3762 38.5055C39.2186 39.0732 39.8737 39.796 40.3193 40.6333C40.7663 41.4721 41 42.4171 41 43.4291V61.0556C41 62.6926 40.3301 64.1798 39.2514 65.2554C38.1715 66.332 36.6813 67 35.038 67H35.0379Z",
    fill: "#ffffff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 49.5,
    x2: 41,
    y2: 49.5,
    stroke: "#ffffff"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 29.5,
    y1: 50,
    x2: 29.5,
    y2: 67,
    stroke: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 33L13.5 50",
    stroke: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSelected);
export default __webpack_public_path__ + "static/media/room-selected.c1e0f1065db4c0569b821cb33b62e6d2.svg";
export { ForwardRef as ReactComponent };